/**
 * Central registry of route paths. Import ROUTES instead of hardcoding
 * path strings in components — renaming a route means editing one file.
 */
export const ROUTES = {
  upload: '/kiosk/upload',
  options: '/kiosk/options',
  payment: '/kiosk/payment',
  success: '/kiosk/success',
  admin: {
    login: '/login',
    root: '/admin',
    dashboard: '/admin/dashboard',
    vendors: '/admin/vendors',
    kiosks: '/admin/kiosks',
    rates: '/admin/rates',
  },
} as const;

/** Ordered kiosk flow steps, used to drive the step-progress indicator. */
export const KIOSK_STEPS = [
  { step: 1, label: 'Upload', description: 'Select file or cloud source', path: ROUTES.upload },
  { step: 2, label: 'Options', description: 'Color, duplex & trays', path: ROUTES.options },
  { step: 3, label: 'Pay', description: 'Card or NFC terminal', path: ROUTES.payment },
  { step: 4, label: 'Release', description: 'Hardware tray output', path: ROUTES.success },
] as const;